// Chakra imports
import {
  Flex,
  Skeleton,
  SkeletonText,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
  useColorModeValue,
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import IconBox from "components/Icons/IconBox";
import React from "react";

const MiniStatistics = ({
  title,
  subTitle,
  amount,
  percentage,
  icon,
  change,
  onClick
}) => {
  const iconRed = useColorModeValue("red.500", "red.500");
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card minH="83px" onClick={onClick ? onClick : null}>
      <CardBody>
        <Flex flexDirection="row" align="center" justify="center" w="100%">
          <Stat me="auto">
            <Flex flexDirection="row">
              <StatLabel
                fontSize="sm"
                color="gray.400"
                fontWeight="bold"
                pb=".1rem"
              >
                {title}
              </StatLabel>
              {subTitle && (
                <StatLabel
                  ml={"3px"}
                  fontSize="xs"
                  color="gray.400"
                  fontWeight="bold"
                  pb=".1rem"
                >
                  ({subTitle})
                </StatLabel>
              )}
            </Flex>
            <Flex>
              {(!amount && amount !== 0) && <Skeleton>Jakis skeleton</Skeleton>}
              <StatNumber fontSize="lg" color={textColor}>
                {amount}
              </StatNumber>

              {change && (
                <StatNumber fontSize="s" ml="5px" color={iconRed}>
                  ({change == 2 ? "Zmiana druga" : "Zmiana pierwsza"})
                </StatNumber>
              )}
              {console.log(amount, percentage)}
              {percentage ? (
                <StatHelpText
                  alignSelf="flex-end"
                  justifySelf="flex-end"
                  m="0px"
                  color={percentage > 0 ? "green.400" : "red.500"}
                  fontWeight="bold"
                  ps="3px"
                  fontSize="md"
                >
                  {percentage > 0 ? `+${percentage}` : `${percentage}`}
                </StatHelpText>
              ):null}
            </Flex>
          </Stat>
          <IconBox as="div" h={"45px"} w={"45px"} bg={iconRed}>
            {icon}
          </IconBox>
        </Flex>
      </CardBody>
    </Card>
  );
};

export default MiniStatistics;
